import React from 'react';

interface HeroPairProps {
  buttons?: React.ReactNode;
}

const HeroPair: React.FC<HeroPairProps> = ({ buttons }) => {
  return (
    <div className="relative overflow-hidden max-md:order-2">
      {/* Cards container - uses flexbox with calculated height and gap */}
      <div
        className="mx-2 mt-8 flex gap-2 sm:mx-4 md:mx-9 max-md:mx-5 max-md:mt-6"
      >
        {/* Card02 on the left */}
        <div className="flex-1 max-md:hidden">
          <img
            src="/Card 02.webp"
            alt="Card 02"
            className="block w-full h-auto"
          />
        </div>

        {/* Card01 on the right */}
        <div className="relative min-w-0 flex-1 max-md:w-full max-md:flex-none">
          <img
            src="/Card 01.webp"
            alt="Card 01"
            className="block w-full h-auto"
          />
          {/* Use the card's alpha shape to keep the portrait inside its curved edge. */}
          <div
            className="pointer-events-none absolute inset-0 overflow-hidden"
            style={{
              maskImage: 'url("/Card 01.webp")',
              WebkitMaskImage: 'url("/Card 01.webp")',
              maskSize: '100% 100%',
              WebkitMaskSize: '100% 100%',
              maskRepeat: 'no-repeat',
              WebkitMaskRepeat: 'no-repeat',
            }}
          >
            <img
              src="/images/Boy_Half.webp"
              alt="Student with backpack"
              className="absolute bottom-0 left-1/2 block h-auto max-h-[88%] w-auto max-w-[90%] -translate-x-1/2 object-contain object-bottom drop-shadow-lg"
            />
          </div>
        </div>
      </div>

      {/* Buttons positioned at bottom - constrained by navbar margins with inner padding for content */}
      <div className="absolute bottom-0 left-0 right-0 z-30 pointer-events-auto max-md:hidden">
        <div className="w-full flex justify-center items-center">
          {buttons}
        </div>
      </div>
    </div>
  );
};

export default HeroPair;
